// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';

import styles from './documentation.module.scss';
import { Button, BookOpen02Icon, Stack, Typography } from '@metarouter-private/mr-mui';
import useTrackWithUser from '@ion/api/hooks/useTrackWithUser';

export const Documentation = () => {
  const [trackWithUser] = useTrackWithUser('views_documentation');

  return (
    <Stack spacing={2} alignItems="flex-start">
      <Typography variant="h6">What are Consent Categories?</Typography>
      <Stack spacing={1} className={styles.descriptionBodyText}>
        <Typography>
          You can use this table to identify your organization&apos;s consent categories. The Friendly Names will be
          used throughout our UI to make it easier for your team to understand how to categorize Syncs and Integrations.
        </Typography>
        <Typography>
          The Categories Codes (eg. C1) will be what is actually used by our system and your team when creating consent
          cookies and consent objects within our SDKs.
        </Typography>
      </Stack>
      <Button
        variant="outlined"
        color="secondary"
        startIcon={<BookOpen02Icon />}
        href="https://docs.metarouter.io/docs/compliance-module"
        target="_blank"
        rel="noreferrer"
        onClick={() => trackWithUser()}
      >
        Documentation
      </Button>
    </Stack>
  );
};
